var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThemeLight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3877",
    "data-name": "Group 3877",
    transform: "translate(-1100 -697)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3485",
    "data-name": "Group 3485",
    transform: "translate(1104 701)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_280",
    "data-name": "Ellipse 280",
    cx: 2.902,
    cy: 2.902,
    r: 2.902,
    transform: "translate(6.098 6.098)",
    fill: "none",
    stroke: "#16161a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_173",
    "data-name": "Line 173",
    y2: 2.492,
    transform: "translate(9 1)",
    fill: "none",
    stroke: "#16161a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_174",
    "data-name": "Line 174",
    x2: 1.762,
    y2: 1.762,
    transform: "translate(3.343 3.343)",
    fill: "none",
    stroke: "#16161a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_175",
    "data-name": "Line 175",
    x2: 2.492,
    transform: "translate(1 9)",
    fill: "none",
    stroke: "#16161a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_176",
    "data-name": "Line 176",
    y1: 1.762,
    x2: 1.762,
    transform: "translate(3.343 12.895)",
    fill: "none",
    stroke: "#16161a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_177",
    "data-name": "Line 177",
    y1: 2.492,
    transform: "translate(9 14.508)",
    fill: "none",
    stroke: "#16161a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_178",
    "data-name": "Line 178",
    x1: 1.762,
    y1: 1.762,
    transform: "translate(12.895 12.895)",
    fill: "none",
    stroke: "#16161a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_179",
    "data-name": "Line 179",
    x1: 2.492,
    transform: "translate(14.508 9)",
    fill: "none",
    stroke: "#16161a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_180",
    "data-name": "Line 180",
    x1: 1.762,
    y2: 1.762,
    transform: "translate(12.895 3.343)",
    fill: "none",
    stroke: "#16161a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemeLight);
export default __webpack_public_path__ + "static/media/theme-light.c0b65d9d416df4520be4772a3d4dfd0c.svg";
export { ForwardRef as ReactComponent };